import React from "react";
import { CheckIcon, AlertTriangleIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { includes } from "../data/salesContent";
import { useCountdown } from "../hooks/useCountdown";
export function Offer() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23);
  return <section id="oferta" aria-labelledby="precio" className="w-full scroll-mt-4 bg-ink py-16 text-cream lg:py-24" data-id="element-108" data-mp="1hph44bz92lv2">
      <div className="mx-auto max-w-6xl px-5" data-id="element-109" data-mp="tzd8aqsazqem">
        <div className="grid items-start gap-10 lg:grid-cols-[1fr_1fr] lg:gap-14" data-id="element-110" data-mp="p00dnjv6xf1h">
          <div data-id="element-111" data-mp="p24mmg7y548m">
            <h2 className="font-display text-3xl font-black sm:text-4xl" data-id="element-112" data-mp="13wrgy47zjawd">¿Qué incluye?</h2>
            <ul className="mt-8 grid gap-x-6 gap-y-4 sm:grid-cols-2" data-id="element-113" data-mp="yxy2o9kvjfv5">
              {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-114" data-mp="2fbog46xvvghg">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-115" data-mp="2fe0vqdg65erc">
                    <CheckIcon className="h-3.5 w-3.5 text-ink" strokeWidth={3} aria-hidden="true" data-id="element-116" data-mp="pk7d7dy7c75r" />
                  </span>
                  <span className="text-cream/90" data-id="element-117" data-mp="uiiolt45apq3">{item}</span>
                </li>)}
            </ul>

            <div className="mt-10 flex gap-5 rounded-2xl border border-ink-line bg-ink-soft p-6" data-id="element-118" data-mp="zjpypytrg0zx">
              <ShieldCheckIcon className="h-12 w-12 shrink-0 text-gold" aria-hidden="true" data-id="element-119" data-mp="13ip059ga9fmm" />
              <div data-id="element-120" data-mp="6usevr9whw52">
                <h3 className="font-display text-xl font-extrabold" data-id="element-121" data-mp="6vahr6r2j8ly">Garantía 7 días</h3>
                <p className="mt-2 leading-relaxed text-cream/75" data-id="element-122" data-mp="btlvvtoec59z">
                  Si en 7 días no es lo que esperabas: devolución del 100% sin preguntas.
                </p>
                <p className="mt-2 text-sm text-gold" data-id="element-123" data-mp="kldzplix0g5l">Tasa de devoluciones: menos del 1%.</p>
              </div>
            </div>
          </div>

          <div className="rounded-3xl border-2 border-gold bg-ink-soft p-8 text-center sm:p-10" data-id="element-124" data-mp="3k6jdohz22o1j">
            <p id="precio" className="font-display text-sm font-extrabold uppercase tracking-widest text-gold" data-id="element-125" data-mp="3o84lhowqgc4v">
              Precio hoy
            </p>
            <p className="mt-6 text-cream/60" data-id="element-126" data-mp="qhflnmx2ou7v">
              Valor regular: <span className="line-through decoration-2" data-id="element-127" data-mp="qetdbl2cyaol">$97</span>
            </p>
            <p className="mt-1 text-sm text-cream/80" data-id="element-128" data-mp="157mv5d53r2wf">Precio lanzamiento</p>
            <p className="font-display text-8xl font-black leading-none text-gold" data-id="element-129" data-mp="107s7rjkjcvg4">
              $17
            </p>
            <p className="mt-2 text-sm text-cream/60" data-id="element-130" data-mp="ch4s2c4dp1j0">USD · pago único · acceso de por vida</p>

            <div className="mx-auto mt-8 flex max-w-xs items-center justify-center gap-2 rounded-xl bg-danger/15 px-4 py-3 text-sm font-semibold text-[#FDA29B]" data-id="element-131" data-mp="7jmhkhapqe8w">
              <AlertTriangleIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-132" data-mp="hfpt2drgfp8i" />
              Sube en{" "}
              <span className="font-display tabular-nums text-cream" data-id="element-133" data-mp="1wvex6xj6zdk2">
                {hours}:{minutes}:{seconds}
              </span>
              . No vuelve.
            </div>

            <CtaButton className="mt-8 w-full" data-id="element-134" data-mp="20ee1rhfn6rvu" />
          </div>
        </div>
      </div>
    </section>;
}